import { useLocation, useSearchParams } from 'react-router-dom';

import { ROUTE_ITEMS } from 'navigation/config/routePaths';
import { PageState } from 'providers/filtersUtils';
import { FiltersParams } from 'providers/HotDealsFiltersProviders';

export const useHotDealsSearchPhrase = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const searchPhrase = location.pathname === ROUTE_ITEMS ? searchParams.get('searchPhrase') : null;

  const applySearchToFilters = (filters: FiltersParams): FiltersParams => {
    if (searchPhrase) {
      return { ...filters, searchPhrase: searchPhrase, sortType: 'BEST_MATCH' };
    } else {
      return filters;
    }
  };

  const applySearchToPageState = (pageState: PageState) => {
    return !!searchPhrase ? 'Filtered' : pageState;
  };

  return { searchPhrase, applySearchToPageState, applySearchToFilters };
};
